<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <!-- <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>
                        <template v-if="ls">
                            事务所信息
                        </template>  
                        <template v-else>
                            单位信息
                        </template>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->
            <span class="back" @click="$router.go(-1)"
                ><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span
            >
            <div class="page">
                <div class="section">
                    <div class="license">
                        <dl>
                            <dt>
                                <div class="license_area">
                                    <Upload
                                        :message="ls? 1 : 0"
                                        sort="1"
                                        @uploadData="getChildData($event)"
                                        @delpic="delimg($event)"
                                    ></Upload>
                                </div>
                            </dt>
                            <dd>
                                <div class="license_title">
                                    <div class="individual">
                                        <p>请在营业执照复印件上手写并加盖公章：</p>
                                        <p>营业执照限用于将账号XXXXX认证为本单位的实名账号</p>
                                    </div>
                                </div>
                                <div class="des">
                                    <p>
                                        *格式要求：原件照片、扫描件、支持.jpg、.jpeg、.png、<br />.bmp格式照片，大小不超过10M
                                    </p>
                                </div>
                            </dd>
                        </dl>
                        <p class="warning">
                            <i class="el-icon-warning"></i
                            >&nbsp;&nbsp;&nbsp;&nbsp;请务必提供真实信息，公司有权自行或委托第三方，审查提供的信息是否真实、有效。若提供虚假信息，由此带来的后果由提供方承担。
                        </p>
                    </div>
                </div>
                <div
                    class="hline"
                    style="position:absolute; width:100%; height:15px; background:#f8fafb;left:0;"
                ></div>
                
                <el-form
                    :model="form1"
                    :rules="applyrules"
                    ref="applyForm1"
                    label-width="140px"
                    class="demo-ruleForm"
                >
                    <div class="form">
                        <h3>{{ ls ? '事务所信息' : '单位信息'}}</h3>
                        <el-form-item
                            label='名称'
                            prop="name"
                        >
                            <el-input
                                v-model="form1.name"
                                placeholder="请输入单位证件登记的名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            :label="ls?'统一社会信用代码':'单位证件号'"
                            label-width="140px"
                            prop="uscc"
                        >
                            <el-input
                                v-model="form1.uscc"
                                :placeholder="ls?'请输入统一社会信用代码或组织机构代码':'请输入单位证件号'"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div
                        class="hline"
                        style="position:absolute; width:100%; height:15px; background:#f8fafb;left:0;"
                    ></div>
                    <div class="form">
                        <h3>申请人信息</h3>
                        <el-form-item
                            label="申请人姓名:"
                            prop="contactsName"
                        >
                            <el-input
                                v-model="form1.contactsName"
                                placeholder="请输入申请人姓名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="申请人身份证号："
                            prop="contactsIdCard"
                        >
                            <el-input
                                v-model="form1.contactsIdCard"
                                placeholder="请输入申请人身份证号"
                            ></el-input>
                        </el-form-item>
                        <p class="form-item-tip"><i class="el-icon-warning"></i>手机号的运营商实名信息需为申请人本人</p>
                        <el-form-item
                            label="申请人手机号码:"
                            prop="contactsPhone"
                        >
                            <el-input
                                v-model="form1.contactsPhone"
                                placeholder="请输入申请人手机号码"
                            ></el-input>
                        </el-form-item>
                        <div class="yzm-item">
                            <el-form-item
                                label="验证码:"
                                prop="code"
                            >
                                <el-input
                                    v-model="form1.code"
                                    placeholder="短信验证码"
                                ></el-input>
                            </el-form-item>
                            <span
                                :disabled="disabled"
                                @click="getVerificationCode"
                                >{{ yzmtext }}</span
                            >
                        </div>
                        <div class="submit">
                            <span @click="onSubmit('applyForm1')">提交</span>
                            <span class="prevBtn" @click="$router.go(-1)">返回</span>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <div id="captcha-element"></div>
    </el-row>
</template>

<script>

import {sendMsg,enterpriseApply} from '@http/user_center/realName';
import { identification } from "@http/user_center/userInfo";
import Verification from "@/components/VaVerification";
import Upload from "@/components/Upload.vue";
import NoTrace from '@/utils/noTrace';
var interval = null;
export default {
    data() {
        var vphone = (rule, value, callback) => {
            if (!/^1[23456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        var vuscc = (rule, value, callback) => {
            if (!/^[A-Za-z0-9-]{6,40}$/.test(value)) {
                callback(new Error(this.ls?'统一社会信用代码或组织机构代码格式不正确':"单位证件号格式不正确"));
            }
            callback();
        };
        var space=(rule, value, callback) => {
            if (value.toString().replace(/\s/g,"")=='') {
                callback(new Error("输入内容不能全为空格"));
            }
            callback();
        };
        return {
            formData: {},
            imgs: {},
            form1: {
                file: "",
                name: "",
                uscc: "",
                organizationType:'',
                contactsName: "",
                contactsIdCard:"",
                contactsPhone: "",
                code: "",
                version:'2',
            },
            applyrules: {
                name: [
                    {
                        required: true,
                        message: "请输入单位证件登记的名称",
                        trigger: "blur",
                    },
                    { min:1, max: 80, message: '输入长度不能大于80', trigger: 'blur' },
                ],
                uscc: [
                    {
                        required: true,
                        message: this.$route.query.ls ? "请输入统一社会信用代码或组织机构代码" : "请输入单位证件号",
                        trigger: "blur",
                    },
                    { min:1, max: 50, message: '输入长度不能大于50', trigger: 'blur' },
                    { validator: vuscc, trigger: "blur" },
                ],
                legal: [
                    {
                        required: true,
                        message: "请输入法定代表人姓名",
                        trigger: "blur",
                    },
                    { min:1, max: 50, message: '输入长度不能大于50', trigger: 'blur' },
                    { validator: space, trigger: "blur" },
                ],
                contactsName: [
                    { required: true, message: "请输入申请人姓名", trigger: "blur" },
                    { min:1, max: 20, message: '输入长度不能大于20', trigger: 'blur' },
                ],
                contactsIdCard: [
                    { required: true, message: "请输入申请人身份证号", trigger: "blur" },
                    { min:1, max: 50, message: '输入长度不能大于50', trigger: 'blur' },
                ],
                contactsPhone: [
                    { required: true, message: "请输入申请人手机号码", trigger: "blur" },
                    { validator: vphone, trigger: "blur" },
                ],
                code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
            },
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 60,
            nvc:'',
        };
    },

    components: {Verification,Upload},

    computed: {
        ls(){
            return this.$route.query.ls?true:false
        },
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },

    created() {
        identification().then((res) => {
            let status = res.authenticationStatus;
            if(status!==-1 && status!==5){
                this.$router.replace({
                    path:"/userCenter/AuthenticationName",
                });
            }
        }).catch((err) => {
            console.log(err);
        });
        if(this.ls){
            this.form1.organizationType='1'
        }else{
            this.form1.organizationType='2'
        }

        if(this.$route.query.ls){
            this.$route.meta.secondTitle='律师事务所基础信息认证'
        }else{
            this.$route.meta.secondTitle='单位基础信息认证'
        }
    },

    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },
    methods: {
        getChildData(data) {
            if (data == {}) {
                this.imgs = data;
            } else {
                for (var key in data) {
                this.imgs[key] = data[key];
                }
            }
            console.log(this.imgs);
        },
        delimg(data) {
            if (data) {
                console.log(data);
                var arr = Object.keys(this.imgs);
                if (arr.length > 1) {
                for (var key in data) {
                    console.log(this.imgs[key]);
                    delete this.imgs[key];
                }
                } else {
                this.imgs = {};
                }
                console.log(this.imgs);
            }
        },
        async getVerificationCode() {
            let that = this;
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35022,
                    "logParam":{
                        'phone':that.form1.contactsPhone,
                    }
                },
            });
            let { contactsPhone } = that.form1;
            if (!contactsPhone) {
                that.$msg("申请人手机号不能为空");
                return false;
            }
            let reg = /^1[23456789]\d{9}$/;
            if (!reg.test(contactsPhone)) {
                that.$msg("手机号格式不正确");
                return false;
            }
            this.getCode();
            that.disabled = true;

            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                phone: that.form1.contactsPhone,
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg(res.message, "success");
                }catch (err) {
                    reject(err)
                    that.$msg('发送失败')
                    clearInterval(interval);
                    that.yzmtext = "获取验证码";
                    that.disabled = false;
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = 60;
                    that.disabled = false;
                }
            }, 1000);
        },
        onSubmit(form) {
            zhuge.track('用户中心_企业认证提交', {'渠道': this.channelCodeValue,'用户行为':'实名认证'})
            let that = this;
            this.formData = new FormData();
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if (!that.imgs[1]) {
                        console.log(this.ls)
                        if(this.ls){
                            that.$msg("请上传律师事务所执业许可证照");
                        }else{
                            that.$msg("请上传企业营业执照");
                        }
                        that.page=1;
                        return false;
                    }
                    let obj = Object.assign({},this.form1);
                    let clientId = this.$getlocalStorage("queryData")
                        ? this.$getlocalStorage("queryData").clientId
                        : "";
                    if (clientId) {
                        obj = Object.assign({}, obj, { clientId });
                    }
                    for(let key in obj) {
                        obj[key] = (obj[key] && typeof(obj[key])=='string')?obj[key].replace(/\s*/g,""):'';
                    }
                    Object.keys(obj).forEach((key) => {
                        that.formData.append(key, obj[key]);
                    });
                    that.formData.append("file", that.imgs[1]);
                    this.$TsaWebTrace.post({
                        data: {
                            "eventId": 35016,
                        },
                    });
                    enterpriseApply(that.formData).then((res) => {
                        that.$router.replace({
                            path:"/userCenter/Entercheck",
                        });
                    }).catch((err) => {
                        // this.$msg(err.message);
                    });
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.mianContent {
    position: relative;
    .back {
        position: absolute;
        right: 30px;
        top: -30px;
        font-size: 14px;
        cursor: pointer;
        &:hover {
            color: #10a0e9;
        }
    }
}

.section {
    padding: 33px 0 41px;
    .warning {
        color: #F09135;
        white-space: nowrap;
        font-size: 14px;
        margin-top: 14px;
    }
}
.license {
    width: 740px;
    margin: 0 auto;
    dl {
        width: 100%;
        display: flex;
        dt {
            margin-right: 21px;
            .license_area {
                position: relative;
                width: 186px;
                img {
                    width: 186px;
                    height: 134px;
                }
                .uploadfile {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }
            h6 {
                font-size: 14px;
                margin-top: 20px;
                text-align: center;
                font-weight: 500;
            }
        }
        dd {
            text-align: center;
            .license_title {
                font-size: 16px;
                padding: 13px 0 19px;
                .individual{
                    margin-top: -15px;
                    margin-bottom: -6px;
                    p{
                        text-align: left;
                        font-size:14px;
                        color: #666;
                        margin-bottom: 5px;
                        &:first-child{
                            font-weight: bold;
                            color: #333;
                            font-size: 16px;
                            margin-bottom: 10px;
                        }
                    }
                }
            }
            .des {
                line-height: 30px;
                font-size: 14px;
                color: #c1c1c1;
                p{
                    white-space: nowrap;
                }
            }
        }
    }
}
.form {
    width: 675px;
    box-sizing: border-box;
    padding-top: 47px;
    padding-right: 150px;
    margin: 0 auto;
    h3{
        font-weight: bold;
        color: #000;
        font-size: 16px;
        margin-bottom: 20px;
    }
    .form-item-tip{
        display: flex;
        color: #F09135;
        font-size: 14px;
        align-items: center;
        i{
            margin-right: 5px;
        }
        &::before{
            content: '';
            display: block;
            width: 140px;
        }
    }
    .submit {
        span {
            display: inline-block;
            width: 130px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            box-sizing: border-box;
            border-radius: 5px;
            border: 1px solid #10a0e9;
            cursor: pointer;
            background: #10a0e9;
            color: #fff;
            margin-bottom: 20px;
            margin-left: 140px;
            opacity: 0.7;
            &:hover {
                opacity: 1;
            }
        }
        .prevBtn{
            background: #fff;
            border:1px solid #10a0e9;
            color:#10a0e9;
            margin-left: 20px;
            &:hover{
                background: #10a1e911;
            }
        }
    }
    .yzm-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .yzm-item .el-form-item {
        width: 350px;
    }
    .yzm-item span {
        width: 148px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #fff;
        color: #3f7df7;
        cursor: pointer;
        border: 1px solid #3f7df7;
        font-size: 14px;
        margin-top: 3px;
        border-radius: 3px;
    }
    .yzm-item span:hover {
        background: #3f7df7;
        color: #fff;
    }
    .yzm-item span[disabled] {
        color: #fff;
        background: #bcbcbc;
        pointer-events: none;
        cursor: inherit;
        border-color: #bcbcbc;
    }
}
</style>
